import { RouterReducerState } from '@ngrx/router-store';
import { RouterStateUrl } from './router.state';

import * as fromUserReducer from '../reducers/user.reducer';
import * as fromUserState from './user.state';
import * as fromStaticDataReducer from '../reducers/static-data.reducer';
import * as fromStaticDataState from './static-data.state';

export interface AppState {
  router: RouterReducerState<RouterStateUrl>;
  [fromUserReducer.usersFeatureKey]: fromUserState.State;
  [fromStaticDataReducer.staticDataFeatureKey]: fromStaticDataState.State;
}

export const getSectionRouter = (state: AppState) => state.router;
export const getSectionUsers = (state: AppState) =>
  state[fromUserReducer.usersFeatureKey];
export const getSectionStaticData = (state: AppState) =>
  state[fromStaticDataReducer.staticDataFeatureKey];
